import React, { useState, useEffect, useRef } from "react";

/**
 * Editable column header for the Media table.
 * Click to edit, blur or Enter to save. Backed by a parent-provided
 * onSave(newLabel) callback that persists to /api/settings.
 */
export default function EditableHeader({
  label,
  fieldKey,
  onSave,
  className = "",
  testId,
}) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(label);
  const inputRef = useRef(null);

  useEffect(() => {
    setVal(label);
  }, [label]);

  useEffect(() => {
    if (editing) {
      requestAnimationFrame(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      });
    }
  }, [editing]);

  const commit = () => {
    setEditing(false);
    const trimmed = (val || "").trim().slice(0, 40);
    if (!trimmed) {
      setVal(label);
      return;
    }
    if (trimmed !== label) onSave(trimmed);
  };

  if (editing) {
    return (
      <input
        ref={inputRef}
        value={val}
        onChange={(e) => setVal(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") {
            setVal(label);
            setEditing(false);
          }
        }}
        className="mono uppercase text-[10px] tracking-[0.22em] bg-transparent border border-oud px-1 py-0.5 outline-none w-full text-foreground"
        data-testid={testId ? `${testId}-input` : undefined}
      />
    );
  }

  return (
    <span
      onClick={() => onSave && setEditing(true)}
      title={onSave ? "Click to rename" : ""}
      className={`cursor-text inline-block ${className} ${onSave ? "hover:text-oud transition-colors" : ""}`}
      data-testid={testId}
      data-field={fieldKey}
    >
      {label || "—"}
    </span>
  );
}
